import { generateTableBody, generateTableHead } from "@/core/table/table-utils";
/**
 * Parse field configurations into export head structure
 */
export function parseHead(fields) {
    const tableHead = generateTableHead(fields);
    return tableHead.map((row) => row.map((cell) => ({
        label: cell.field.label,
        colspan: cell.colspan || 1,
        rowspan: cell.rowspan || 1,
        color: cell.field.color,
    })));
}
/**
 * Prepare data for export
 */
export function prepareExportData(fields, data) {
    const parsedHead = parseHead(fields);
    const parsedData = generateTableBody(data, fields);
    return {
        head: parsedHead,
        data: parsedData,
    };
}
/**
 * Download a file from a URL
 * @param url - The URL to download from
 * @param filename - Optional filename for the download
 */
export function downloadFile(url, filename) {
    filename = filename || url.split("/").pop() || "download";
    // Create download link
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
